import axios from "axios";
import { SERVER_URL } from "../const";

export const searchTradeData = async (hscode, assessableValue, igstRate = null) => {
    const token = localStorage.getItem('token');
    try {
        const params = {
            hscode: hscode,
            assessable_value: assessableValue
        };

        // Add IGST rate if provided
        if (igstRate !== null) {
            params.igst_rate = igstRate;
        }

        const response = await axios.post(`${SERVER_URL}/trade-search`, null, {
            params: params,
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        if (response.status === 200) {
            return response.data;
        } else {
            throw new Error(response.data?.error || "Search failed");
        }
    } catch (error) {
        console.error("Trade Search Error:", error);
        throw error.response?.data?.detail || error.message;
    }
};

export const searchHscodeOnly = async (hscode) => {
    const token = localStorage.getItem('token');
    try {
        const response = await axios.post(`${SERVER_URL}/trade-search/hscode`, null, {
            params: { hscode: hscode },
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        if (response.status === 200) {
            return response.data;
        } else {
            throw new Error(response.data?.error || "Search failed");
        }
    } catch (error) {
        console.error("HS Code Search Error:", error);
        throw error.response?.data?.detail || error.message;
    }
};

export const searchHscodeAutocomplete = async (searchTerm) => {
    const token = localStorage.getItem('token');
    try {
        const response = await axios.get(`${SERVER_URL}/trade-search/autocomplete`, {
            params: { search: searchTerm },
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        if (response.status === 200) {
            return response.data;
        } else {
            return [];
        }
    } catch (error) {
        console.error("HS Code Autocomplete Error:", error);
        return [];
    }
};
